import type { ComponentType, ReactNode } from 'react';

import classNames from 'classnames';

import CustomStoryStatCard from './CustomStoryStatCard';

export interface CustomStoryStatCardData {
  Icon: ComponentType;
  stat: ReactNode;
  name: ReactNode;
  description?: ReactNode;
  className?: string;
}

interface CustomStoryStatCardsListProps {
  items: CustomStoryStatCardData[];
  className?: string;
}

const CustomStoryStatCardsList = ({ items, className }: CustomStoryStatCardsListProps) => {
  return (
    <ul
      className={classNames(
        'story-prose-none flex flex-wrap gap-7 md:gap-[3.25rem] p-0 list-none',
        className,
      )}
    >
      {items.map(({ name, Icon, stat, description, className: itemClassName }, i) => {
        return (
          <li key={i} className={classNames('flex-grow story-prose-none', itemClassName)}>
            <CustomStoryStatCard
              title={name}
              className="h-full"
              description={description}
              stat={stat}
              icon={<Icon />}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default CustomStoryStatCardsList;
